let _targetSiteId: number | null = null;

export const TargetSite = {
  get(): number | null {
    return _targetSiteId;
  },

  async withSite<T>(siteId: number, fn: () => Promise<T>): Promise<T> {
    _targetSiteId = siteId;
    try {
      return await fn();
    } finally {
      _targetSiteId = null;
    }
  },

  /**
   * Synchronous scope, for RxJS call sites that build cold observables instead of awaiting.
   * HttpRequestDecorator stamps X-Target-Site-Id when the observable is *created*, not when it is
   * subscribed, so creating the requests inside `fn` is enough — subscribing later is fine.
   */
  withSiteSync<T>(siteId: number, fn: () => T): T {
    _targetSiteId = siteId;
    try {
      return fn();
    } finally {
      _targetSiteId = null;
    }
  },
};
